/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowsDown = createReactComponent("arrows-down", "IconArrowsDown", [
  ["path", { d: "M7 21l0 -18", key: "svg-0" }],
  ["path", { d: "M20 18l-3 3l-3 -3", key: "svg-1" }],
  ["path", { d: "M4 18l3 3l3 -3", key: "svg-2" }],
  ["path", { d: "M17 21l0 -18", key: "svg-3" }]
]);

export { IconArrowsDown as default };
//# sourceMappingURL=IconArrowsDown.js.map
